if (!customElements.get('sticky-cart-bar')) {
  customElements.define(
    'sticky-cart-bar',
    class StickyCartBar extends HTMLElement {
      connectedCallback() {
        this.priceWrapper = this.querySelector('.toylivo-sticky-cart__price');
        this.variantLabel = this.querySelector('.toylivo-sticky-cart__variant');
        this.image = this.querySelector('.toylivo-sticky-cart__image');
        this.variantIdInput = this.querySelector('input[name="id"]');
        this.submitButton = this.querySelector('.product-form__submit');

        this.onVariantChange = this.onVariantChange.bind(this);
        this.unsubscribe =
          typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
            ? subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange)
            : undefined;
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      onVariantChange({ data }) {
        const { variant, html, sectionId } = data;

        if (this.variantIdInput) {
          this.variantIdInput.value = variant ? variant.id : '';
        }

        if (this.variantLabel && variant?.title && variant.title !== 'Default Title') {
          this.variantLabel.textContent = variant.title;
        }

        const sourcePrice = html?.getElementById?.(`price-${sectionId}`);
        if (sourcePrice && this.priceWrapper) {
          this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }

        if (this.image && variant?.featured_image?.src) {
          this.image.src = variant.featured_image.src;
        }

        if (this.submitButton) {
          const unavailable = !variant || variant.available === false;
          this.submitButton.disabled = unavailable;
          const label = this.submitButton.querySelector('span');
          if (label && window.variantStrings) {
            label.textContent = !variant
              ? window.variantStrings.unavailable
              : variant.available === false
                ? window.variantStrings.soldOut
                : window.variantStrings.addToCart;
          }
        }
      }
    }
  );
}
